import PolicyCreateComponents from "../components/PolicyCreate";
import usePolicyProps from "../hook/usePolicy";

const PolicyCreate = () => {
  const policyProps = usePolicyProps();
  return <PolicyCreateComponents {...policyProps} />;
};

export default PolicyCreate;
